<template>
  <div class="expandable-resume">
    <p class="resume-text">
      <strong style="margin-right: 10px;">
        <!-- Opdateret {{new Date(resume.generatedOn).getDate()}}. {{ new Date(resume.generatedOn).getMonth() | monthName}} -->
        {{title}}
      </strong>
      <dynamic :comps="[resumeComponent]" :emptyView="{template: '<span></span>'}"></dynamic></p>
    <div v-if="resume.shortVersion && expandable" class="expander">
        <div class="gradient"></div>
        <router-link :to="{ name: 'person', params: { id: resume.lassoId.substring(6) }}" v-show="!loading" >
          <Button theme="pink">VIS MERE</Button>
        </router-link>
        <div v-show="loading" class="loader">
          <Loader />
          <span>Analyserer netværk..</span>
        </div>
    </div>
    <LassoxSignupWall v-else-if="showSignupWall" path="dashboard"></LassoxSignupWall>
    <script v-html="structuredData" type="application/ld+json"></script>
  </div>
</template>

<script>
import Vue from 'vue'
import { EventBus } from '@/assets/js/helpers.js'
import Loader from '@/components/Loader'
import LassoxSignupWall from './LassoxSignupWall.vue'
import Button from './Button.vue'

export default {
  name: 'expandableResume',
  props: {
    'resume': {
      type: Object,
      required: true
    },
    'expandable': {
      type: Boolean,
      default: true
    },
    'goToByExpanding': {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Erhvervsresume'
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    resumeContent () {
      return this.resume.content ? this.resume.content.replace(/(<br\/?> *){3,}/g, '<br/><br/>') : ''
    },
    showSignupWall () {
      const paragraphs = this.resumeContent.split(' ')
      return paragraphs.length > 200 && !this.resume.shortVersion
    },
    resumeComponent: function () {
      let resume = this.resumeContent
      if(this.showSignupWall && resume) {
        const lastParagraphIndex = resume.lastIndexOf('<br/><br/>')
        if(lastParagraphIndex > 0)
          resume = resume.slice(0, lastParagraphIndex) + '<span class="walledText">' + resume.slice(lastParagraphIndex) + '</span>'
      }
      return {
        template: '<span>' + (resume ? Vue.filter('linkify')(resume, false, false, this.$store.state.names) : '') + '</span>'
      }
    },
    // https://developers.google.com/search/docs/appearance/structured-data/paywalled-content
    structuredData() {
      return {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": this.title,
        "author": {
          "@type": "Organization",
          "name": "Lasso X",
          "url": "https://www.lassox.com/"
        },
        "isAccessibleForFree": !this.showSignupWall,
        ...(this.showSignupWall &&
        {
          "hasPart":
          {
            "@type": "WebPageElement",
            "isAccessibleForFree": !this.showSignupWall,
            "cssSelector": ".walledText"
          }
        }
        )
      }
    }
  },
  methods: {
    expand: function () {
      if (this.goToByExpanding) {
        this.$router.push({ name: 'person', params: { id: this.resume.lassoId.split('-')[2] } })
      } else {
        this.loading = true
        EventBus.$emit('loadLongResume')
      }
    }
  },
  components: {
    Loader,
    LassoxSignupWall,
    Button
  }
}
</script>

<style lang="less">
@import (reference) "~@oldShared/lasso/style/constants/colors";
  .expandable-resume {
    display: flex;
    flex-direction: column;
    height: 100%;

    p.resume-text {
      overflow: hidden;
      flex: 1 1 auto;

      margin: 0;
      line-height: 26px;
      color: #555;

      strong {
        font-weight: 500;
      }

      a {
        color: #555;
        &:hover {
          color: #FF8E61;
          text-decoration: none;
        }
      }
      h2 {
        display: none;
      }
    }

    .expander {
      margin-top: -78px;

      .gradient {
        height: 78px;
        position: relative;
        z-index: 1;
        background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
        background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
        background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 );
      }
      .btn {
        // margin-top: 15px;
        padding-left: 30px;
        padding-right: 30px;
      }

      .loader {
        height: 51px;
        display: flex;
        padding-top: 5px;
        justify-content: center;
        align-items: center;
        img {
          height: 45px;
          width: 45px;
          margin-right: 12px;
        }
        span {
          font-size: 16px;
          color: rgba(97,97,97,.7);
        }
      }
    }
  }

  #app.xxs, #app.xs {
    .expander {
      text-align: center;
    }
  }
</style>
